import {ButtonPrimary, ButtonSecondary, Input, ModalBase} from "pac-ux-components";
import React from "react";

function AddPacProductModal(props) {
    const [saving, setSaving] = React.useState(false);
    const [pacProduct, setPacProduct] = React.useState({
        name: '', clientId: '', ourPrivateKey: '', theirPublicKey: '', clientSecret: '',
    });

    return (<div>
        <ModalBase
            style={{display: (props.display === true) ? 'block' : 'none'}}
        >
            <form
                onSubmit={async (e) => {
                    e.preventDefault();
                    setSaving(true);
                    await props.handleSave(pacProduct, 'POST');
                    e.stopPropagation();
                    return;
                }}
            >
                <div style={{
                    width: '619px',
                    paddingLeft: 33,
                    fontFamily: 'Inter',
                    maxHeight: '70vh',
                    overflowY: 'auto',
                }}>
                    <div style={{
                        width: '100%',
                        color: 'black',
                        fontSize: 24,
                        fontWeight: '700',
                        marginTop: 38,
                        marginBottom: 32,
                        wordWrap: 'break-word'
                    }}>Add PAC Product
                    </div>

                    <div style={{
                        width: '100%',
                        color: 'black',
                        fontSize: 16,
                        fontWeight: '400',
                        wordWrap: 'break-word',
                        marginBottom: 4,
                    }}>PAC Product Name
                    </div>
                    <Input value={pacProduct.name}
                           onChange={(e) => {
                               setPacProduct({
                                   ...pacProduct, name: e.target.value,
                               })
                           }}
                           required={true}
                           style={{
                               background: 'white',
                               borderRadius: 2,
                               border: '1px #949494 solid',
                               width: 530,
                               height: 40,
                               margin: '8px 0px'
                           }}
                    />

                    <div style={{
                        width: '100%',
                        color: 'black',
                        fontSize: 16,
                        fontWeight: '400',
                        wordWrap: 'break-word',
                        marginBottom: 4,
                        marginTop: 22,
                    }}>Client Id
                    </div>
                    <Input value={pacProduct.clientId}
                           onChange={(e) => {
                               setPacProduct({
                                   ...pacProduct, clientId: e.target.value,
                               })
                           }}
                           required={true}
                           style={{
                               background: 'white',
                               borderRadius: 2,
                               border: '1px #949494 solid',
                               width: 530,
                               height: 40,
                               margin: '8px 0px'
                           }}
                    />

                    <div style={{
                        width: '100%',
                        color: 'black',
                        fontSize: 16,
                        fontWeight: '400',
                        wordWrap: 'break-word',
                        marginBottom: 4,
                        marginTop: 22,
                    }}>Our Private Key
                    </div>
                    <Input value={pacProduct.ourPrivateKey}
                           onChange={(e) => {
                               setPacProduct({
                                   ...pacProduct, ourPrivateKey: e.target.value,
                               })
                           }}
                           style={{
                               background: 'white',
                               borderRadius: 2,
                               border: '1px #949494 solid',
                               width: 530,
                               height: 40,
                               margin: '8px 0px'
                           }}
                    />

                    <div style={{
                        width: '100%',
                        color: 'black',
                        fontSize: 16,
                        fontWeight: '400',
                        wordWrap: 'break-word',
                        marginBottom: 4,
                        marginTop: 22,
                    }}>Their Public Key
                    </div>
                    <Input value={pacProduct.theirPublicKey}
                           onChange={(e) => {
                               setPacProduct({
                                   ...pacProduct, theirPublicKey: e.target.value,
                               })
                           }}
                           style={{
                               background: 'white',
                               borderRadius: 2,
                               border: '1px #949494 solid',
                               width: 530,
                               height: 40,
                               margin: '8px 0px'
                           }}
                    />

                    <div style={{
                        width: '100%',
                        color: 'black',
                        fontSize: 16,
                        fontWeight: '400',
                        wordWrap: 'break-word',
                        marginBottom: 4,
                        marginTop: 22,
                    }}>Client Secret
                    </div>
                    <Input value={pacProduct.clientSecret}
                           onChange={(e) => {
                               setPacProduct({
                                   ...pacProduct, clientSecret: e.target.value,
                               })
                           }}
                           style={{
                               background: 'white',
                               borderRadius: 2,
                               border: '1px #949494 solid',
                               width: 530,
                               height: 40,
                               margin: '8px 0px'
                           }}
                    />


                </div>

                <div style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    paddingRight: 32,
                    paddingTop: 24,
                    marginTop: 16,
                    paddingBottom: 24,
                    borderTop: '1px solid #E0E0E0'
                }}>

                    <ButtonSecondary
                        onClick={() => {
                            props.closeModal()
                        }}
                        style={{
                            marginRight: 32,
                        }}>Cancel</ButtonSecondary>

                    <ButtonPrimary
                        type='submit'
                        disabled={saving}
                    >Save</ButtonPrimary>
                </div>
            </form>
        </ModalBase>
    </div>);
}

export default AddPacProductModal;